import autoTable, { CellHookData } from "jspdf-autotable";
import jsPDF from "jspdf";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PeriodicStatement } from "../components/periodicStatements/PeriodicStatementsApi";
import logger, { LogTagKey } from "../utils/logger";
import useApi from "./useApi";
import { getExternalLinks } from "../utils/country";
const BITS_LOGO_BASE_64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAB7CAYAAADOgb2OAAAAAXNSR0IArs4c6QAAFpBJREFUeNrs2k1oHGUcx/GJWhtpVdD6Ar7UqEipqEg8tIK4Uk0zO88zO88zDMEmu/v8pzGHiOLFixdzUk96EMSDPQlVI2Lq0YtYL9KLJw0qUgMqCmpobVrb5sV5IlWQJDNpShbW7wd+hEAyu3vYH8/zf54AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuGg9S0tLG07gs3l6lgPg/2NiYuKyev3Azti4J3TSHrjY+P8PTfPRemP4vig6cGccj940MNDc5p9/Kd9rHOdXDybujihp98dx67F6mj/UaMhtA83mNgoM6HJZll2lUve8Tt2MTmVjse64sm5aWfm8+H0qMu6VMHGJ1s2+3Vl2ZbABYfjM1sG4db9K3Ivauk+VlW+Uke+1lekiH0fWvaC125Vl2eUBgO6UZQevU8a9o60sXaIsFpnXqZwpfs4W+VYZOaJM++l65m72W8f1l1W4NWrIw5FxH2ib/xxbObf8Ov++3tnY5j9pI4dD7fZQWkB36vHbK2XlWEkJbSQLRU4r62aipH24SH+wDr58dOp2KeMOaSsniyyuVpTKym/+7+r24M4AQHfxZRDGrQe1cb9UKp+NF9cpZeToYDJaqzpv8nOw0MqQsvLDhbJaI/PKyFeRcXnmt6AAukd//9gWneShMjLnv/CblD+Vlc/8Fq/KQN5vI5Vtv6Rtfr7i82dVIm8Y07o+ANA9/CBbGfeUnwEVWdq85H+oRN71p5MlK62eMGnfFa1vxjanjbynVPP2KqeO/tBhX1FuNf3kjtWyv5jz/XPiCaAzsmzsWtVwL/ut1OYWlixoI8cj656rOde7VmHF8cjdvoD8drB6YblJX4blhT18jfanmEbeVlbeXyk6zScj695StjXkh/8BgI7oCe3wrZFxU3GaL2xuYfnkc8q6j3TW7AvWoLLWLZGRVyuXqpETysihMJMbgjUt9Wg92rf87FROaCvnVslZZfOvtXXjxYqUwgI6wW9vwmx4tzbyZZUiUEYW18yFFVD1zCsr02GjNVSr1a4IVuEvitYT57SVX8ueGf892P9Om/azxTN7yw4ckqTdr4vSLCnDRZXKF5FxloupQIf4koga7hFt5MeSldB5ZZa/sNmgyff+NwPF8HwwGakVpdLURt5UVma0lWortjT/XVv3Wi0b375WsSgz8oA2MlW2ylJWzvg7X3XTuqfKgYNK2vu0lWMl280FZeST0Lo9AYDOGBsb2+JXDdq42QqnekcGTPPGoFiVrZSJIr5Y9hYD7P1p+97Itl9X1p2qNm/KJ7Ue21F2Gz9MWqHy5ZKufECg0tyX1dGo0Xrcv5fywna9/vP7FVlpYdv8Q39fLQDQGbXa+HY/9NbWnS4plZPRX+2df6xkZXnHZ0j7h8aU8gdVW2JTrbWitSquDdEUaLZ7d+a875nzvrMT2V3unPc9u13cKpIFKSjGEAhIUVoL/aHQFItAm9gWGxaUWsAqYrHYqhBXY12ggCC7FLLr4uqyV8/n3HPNOrkz7zv3XmZzh+eTnCxk771zZuA893me9/t8n8z9ldbbXhyr7ep0/InK+n+JyLQIPv/GLGDMCFFq87cl1l2nrNvNfekySKVd/4yy7tvKuGta6ZY31eVlEEpNZftbtXV7Q0FVGX9tlrlfbgiCcFRokjGl1l9NBhEYs/l+27gLxhl3IRgkWb5d2+LgyJ5Tl6a2u5sAxz3FBMOZmXKUKOu/VXfcpiTz2zi9W1f2osq06tjGGLTb7mXMJdL8DzTx9yjrL5GGuyAcNS46Rve2/oY2xc5Q/6a8HkyN6zXGAKlCssFZ5gkD2Qv9sXs6Hfc7E25oN7N3bHuV6rprIvpi3yUwlqeK0nAXhMkx2Mgufldb/9WIUZf725l747gOEIlxpxOwwhmW/2JrIcOaEAQfZf2btS0+E9Z3FffSnG9Mhib3ttAX5M/y38X3S3hhQ5+nZfwp2vrHghmQdV9K040vHVeQmlr/J+iYQj0sZdzt6MFGPcTMBdIkH3ZRrmFfM/BgNzlY4O8Gv77X2/EinRXrIiQdc6n1n03M7GtDr8+p45hZWJP/DlrrFyebNh2n1KZXJx0/w+QBJXj5zx9sp+48ZXJPwJxJt/wm5fCpvd5L6vd6jAQy4QWBK0s2Zf07aFyHTwiLm2m4j5O9JcnsaxPjdkY03ferzF2fJJuOGyVu1SZ/r7bF5UMv4z6UZPk2lOuNGnp0yuSbddd9aPDrU+OuUMZ/Spvg++f+d3VscVXw9Y3PdTnGE1OOM+ZTjxydrkx+g7IOby8U+iOcKMhW3cPauJ3tUme2Xm9ek6bFr1J+S+ASphoebGXcOcEMqIu7gvvL2Bk6vs4QKLL+u5Vx/z86GDgEp4+1M/8+spShWrG0OE1b9/jIn8X7MP4WBp4X7iNBFGr8HYGSb2UuQy+u+Id1o087myeXmV1itrw+Me58Zdy9yvL5Lun+6Ls9gTaNjGxG568j8ypfQ2YdhamjWWUf1l8dUqcTdJT1WxsAgbKt1dp6gurk78J5NEbSoIz7Ar2kYaZ+BDLV6W9gWDpi4PkTJ55IqTQvCk1ssVZb98BEAhaBx/q/TpLtQzNFskjEt5TAyvpnlHErcV9z/CyErZzK2tIHTAa0hVXJSWX/ZugJGaZ9mf9c+IFwj6vMnYpMYfAiS+PCyYDyZj0Po3U3K4N6PRis5iq5gHFX8jNG9cK07Z8VMUf4pMrcxQulESVsSrll/eOTmYt030ciQQbVWAR6T7rj/hi9GNng8zFMzueeZP6T2PE0BGG1QZ9kWNmWmNnXK1vsjpgfPKCy/DaNNfHi105l/X8r1PJkTPFZw8HE+js5fRzVf2nZrScgCNWhTLBSq7vZRk2yaftx2vj34I01iYCljPt2kuVbyDIX+++AoaDmHgOfz7Kvqgx3axqCsNrg4RnWFK9nCCMf5pXv93A6l2T+jJAYlcCqrf9yhIf8V5WZfXujRqn+rynrL8OaeQLZ1Vx5fblt3PrB90OJqjpOa+vvm8Bne0hTbuIDJgirkOawUrFl/YbJm/YRWDh1dA8wEhRSjvPwE4SUdY+GtFzKuH9n4Hkhg+x0Np+YWncDfzeRQGH9rfTiBvpHzXa7/1va+o9r+7zfx2FOGtu2f2bVChCEaWF+6De/kNOpCQerA4zhtK1zHMXHuKG2je9o6wMNdxZc+H9kgHr+/V30C8wcMggd6KWt1PUsBoDrylVmg58z40OsIxvD8/6H+HnNW+kUe3CzoKFfB7zDIz7bPdq6y1Vv9hUicRCmil5p5aK77p8nm12hmHe70CqdemrvJfHSi+KdwYZ72WxWxn2UXtHPVoJ1/QxlYm3Mt+/IC6kGPzNSOnCA7xl5Gf9/2hSXD2qwZuy2l6vMX6Js8Uy4pPT7WZ6Bu6my5XwjM5Im99r4Harrr9ZddzuBjxPBwdlP9Flo5SjzZfGGMHXMCyrdtyZdDhI8sKlZb90ayr2Y4eTE+A9HZIKPKuPOIyNbKHnTbrlw1foPJF3/4SMvbf1HyuvG8no8nO0QiPxN2hYf4XuHXsZ/ENW8G8ga2+V8pDLuBsrgQE/vaWXdjUm5xZoTV8aakGWQKRKA2Gjd6vWOJyCxmJYltbXG7XB9PYAWa+3acvhbEKaKsscyv+PP75lgsBrUXt3Vzja9MRS00nIUBZlERKm5C8V4jK0MX8Nafb4neJ/W38q8JRqxpQyXsxVIG38bfbTArOYXE5snjBHF3D9zl9oUl3JwoYx/RFn/p5VgVRCmDYJEYvunDTTcJ3zRp8l3JsmmV9JvGXafaVq8RVsXWPBalUf3KFO8PUYweXI9lI1KPKTw17a4fl3n9GAgGHr/Nv99Zf3nuMfA/d+puq6Nti3Wwof30U7dekrGdrd4i2y6FqYSSgxWxgf91+v17wSXEddB/K7SIQ3hgG7qSYSW9J2G3SdlFtuiQ3qu1BY7ycZims2ozVXmzo5o5O9lOQWjPkt2g8i2vJUSWNcZ1qht1biuEkjTdOsbKIXpM/IZkKmFhqclWAlTCwEC98wIrdQBfKrYajPs0l1/i+4Wt2nj78LznZ4PDeCoURiCofGfX5/239BYBPo2DC5HaMX2c0JXPuhRbhIMUitTXBGwvZmr3otxFww/IAiTpme8BtErjq5Rn0fXP6ys/6w29MVcgUMDOrQZe8bLmROsSl5BeAFRzRDSMwlvnnG726bfoTcy6mqXs2utbNur0CAlNt+SkFHY4nsRivfDKO1pFi/2INJ8bpviPE7pApnaU7rr/6y1mfGeIE1sYupG+qFR7z81/hsIW5dz6sZ70Ma/l7GhsQ4ncGk1BT3G72jj+GXw0fLyaNKwkqYpL9IF4QXAT5qIKzmGjzjO/8qYiukmHk3sGFRZfomOaeozc5i5q5AvLLov0bqryDwCmdDDqXHncEIX1b/bUDbCrf88QWmkELTr79J69pRASRZ+vU6xNl2GHox9kTTt510d5n3rq2HwUvMlS12FqYYHqFUKKoPH7JYHxN3K0oWlvAanWKzaitA6HcCTip7N4KzjumrWMfQz+Lvi68oWJqaPwwPeNl6p8AnhwWqBhna/3VgmrMCvbXweXQkRa5W5GldmsMU12vg/IIsTdwZhKqlGcky+OaJce5bNybVp39hgsaJwGw33bn5YDU/3tr1i8D459dMMVY/uh7HA4j84TYwpkdh9qEzR19Z9L2gqaPzfYY7XWD5VVqtMcSUjRpSiKzUOVOux/qjMUE+QxrswdWDFi8gx4mF4mhM8BneXrKS3W85kpCSUyaBTwupmcIGF6jqNu2ZoaSrN/6y0tmlEYOpsJ8LB4Um0TWSYK7Vhm6wT0WdtyfxstEdX2ADxfvzHyFJlSYYwTTTrB/aGgD3JHGLEdpZvXOpv7cqobr7ZfCCcYflblCLDGlgR1vV5xGr6fcr4v2/1/PEx7585O2XcFYHMj0Dyv4l1ZzELuJLlOItY29afqbJqUPrRlRmILg6RZerMZZVERBCmhKbWrPXyXwmd3pEFtHS1lr25lGyCB1NZfy3N4pitzwOShGar5Y9nCQPizdC+RLKWmAd1Yd09PbPyOhRYS38fQ9eRDfd4SsU894p1M++PYE0jnWHn5fS35ucL3VWYKIpFsjAVHOFx/lj4N3ZxNxtaluoEQTOYZnhE2fM0tsJIEn7uPm3xyrAlC7OJxW5EsDH6JGbzcE6l7xMw0SNjuYNFrY3l0+T9UKotZidNYK/cHIz/Cw45lHH31WXwPj2eGJevuxOhrQw/C1MBD7XquHZYiOl+xAkfeq2llD38lsf2WJEdBbReyCvwxeIhO/Jn4EKKgJKvGZkJdUutlM3T2EBK2aTDVi8HcVJNLGNDy5OQ4N7ALCIShFHlNb1CDAcJqNXyDptfrUy15v+/6q3Th2IcT2nAc7DQEITVDg8sa7CCa9lZ9pD5j/fYwBJPEzFj2itek1j3fmWLRyKyq0P1A3kK3/9zIzlm9hRt/Nciejd3I1htRPA2+mLG5xEuDXh2Xac3YhWzZJo07Fk4kRh/E7o0mu6x2Q/yC0S5SDDYWKQQkBK8Q57y1r+P120IwmqH/5E5+QqWWZjGGX8hItCQ6wN2LtXP7bpXd2zfkBlQcsYYAyrrfqAyd+PggtYq8Nk8jRC3HqQHRGbSCFIvgbDuLPo9YUmDuwZ907BgFLP1mrIYLVc9s/gQPSaU6rVIthlbxpOhocwPNejxck9tcVF134KwymnyYNdWLYdHBizWepnib3SWdxFkDr/8Bk7yEpufO99vcl9HjR0rflTW7VadvD9YKq3t9Y5lrViE9GA/mRAnio0wNLt/BW0Y/aGwVCL/VN3Abh5ZUjPTp7v56+qB6Obo5n5+LUp+PtP62svnT5ZHgCfYx5TY9NK0df/EgHlomFyb/MJqIa0grGpqHRAlWESp9hzBgnnAYRers+qLNV2ccB0cbxtMsT8x/pMEkcHAkm7c+FIcN8Nq/GKPyvxlsQPBnDxi8kfACjqjWv9NZXOEr2sILhjx0StjqUVi/MdS4/6QJv5igZFGusryyyjRBj7ruTor/BYZXDtzs620/yaCH++hDoDQpHxnNInhZ9WlIe/DJbYppRiZ314FcEFYzfCbulKOG//gRPyuwsZ4/4m75mIPPLOI2rq/ZYYukFE8pDp+6zglcZr57Zph6QhrZFTpyvjbtC2uU2WGg9QDhwdKVWWKCxYJDE3KW23yHdq4BwOr054jCHG4obLiYrRZDFpX7hTWucr+xlSB6kuUsMqGB8nxr09tnsh8obDqodmbGGd1t14df/SuH8+7ZLp3nnTSSb+4WM+mg62wDS54Rdz6DSyDG5HUi1V7yw7a2O5Ydz2Z1GBA1JmbxUd+TBX7YcrQWuLxVG2Xc2jMn7GPrA0nCpkrFFY9eDq1Tf4eHoyjmVmxZCEx7nzKoGHSC4azOaIPZxTuC+32pl9vREIJR9NbGXdHcCg7bItzT9LxM2RVC4LQavSmzAw5ZZz8cg//tbbJfaVnE4RVTq0HclcuPKiTvgiUyrj/SbLi3HqguDlsrVer63R4JMdh/vfp8uvHeUCbSAVYZ7/8bdAMT7v3141zaOILRjDW1t+va93UJC7uhdNfem2SXQnTQBNfK47Yj0KwmlOMnRj3mXbmHI3vUeMuiB6TrivoFYVKoMS4j7FVZlwtGgsoMDBcZvA+iL6Kk9fBWcGk67cz28fg9wQ2aO+h38fhgCjchemgPiGkbJhUoEK2wIAxr5mY4nJ6TQSLkP6IRahJmQEFGu5cj5GtLdVxVc+Xxw8RUJcRiJk3VAPvqYmsQGdFSxv/CcwFn6es9jl6cYz0tEtrHQlWwtRAX6heN/XE87kmnYZ6Paz8BKdbiXV/3u7m3XGEjGQoaI4ilmN8k6CwxAh+DKMyyuaXoAVbomPCXCWQzfwHFhPYsq6rU/2ScOcwYoTEAdvjqAAZ3hC0Fy/8xBbnUgaKVbIwVdBsTtLiNPQ/qfWPrMQ1rwtyLEz4rrZuV3ndq7v+0/zGL//c0cqKddUs4pg9lfXl0gZt3O2jXpvXReHOgodGgKCjBAHF+Lu0dXsj+06HaqX8Lk1J2CnMiOymiQgWOQnjSkgj+D5OAscKXgQp4/eRUfHZaOsuTTqzM/wiEGcGYeqoNFiqHJ0xxbvSbv/slbiqkirz72bYVqVstukr+ij0dE4OLEgIb6TO/ajXZrwGT3NGXFbiMEJn/Zay+WVorggomPfVG6p/UItMn0J7Vbuf/iuHF/TZZqx/M6evMcERyQNOGfOzjMWluutvoo/GLxEyNUSwvA5TBmRQtSPqd9Craetu5hcBnzfD0e2eexmOrA1BmFbIAhhmXskLXyeCU634bq6UBQ4/N/j6ywiKi9m8cHJJJlSZBhp3vrLuYjIZ/mTcJSVYWL+h3Zn9vU65WBVNF1KGcV8LJ1UCzvpyjT6yiHpM52zVLS5grT5XlY11cUXNt6iO01q7NZxAIlQVG2RBECoIBgTg1uazfolyC60Yf5IdESRRkI8rGwgtQOUgAjvptb1tx/I6XPzzfHDa8SJ6YVL2CcJwmsu5pAEsCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIgCIIwOX4KOQG3Hh2/hEAAAAAASUVORK5CYII=";
interface IUsePeriodicStatements {
  downloadStatement: (statementId: string) => Promise<void>;
  userStatementList: UserStatementItem[];
  loading: boolean;
  errorMessage: string | null;
  totalUserStatements: number;
  getUserStatementList: (cursorDirection: string) => Promise<void>;
  setActivePageNumber: (activePageNumber: number) => void;
  activePageNumber: number;
  statement: PeriodicStatement | undefined;
  downloading: boolean;
}

export interface UserStatementItem {
  id: string;
  periodStartDate: string;
  periodEndDate: string;
}
export const DEFAULT_USER_STATEMENTS_PER_PAGE = 24;
export const CURSOR_FORWARD = "forward";
const CURSOR_BACKWARDS = "backwards";

export const usePeriodicStatements = (loggedInUserMembershipNumber: string | undefined): IUsePeriodicStatements => {
  const externalLinks = getExternalLinks();
  const SUPPORT_EMAIL = externalLinks.email ?? "usa@getbits.app";
  const { t } = useTranslation();
  const [downloading, setDownloading] = useState<boolean>(false);
  const [membershipNumber] = useState<string | undefined>(loggedInUserMembershipNumber);
  const [userStatementList, setUserStatementList] = useState<UserStatementItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [totalUserStatements, setTotalUserStatements] = useState<number>(0);
  const [activePageNumber, setActivePageNumber] = useState<number>(1);
  const [lastActivePageNumber, setLastActivePageNumber] = useState<number>(1);
  const [, setCursorDirection] = useState<string>(CURSOR_FORWARD);
  const { periodicStatements } = useApi();
  const [periodicStatementsPreviousBackCursor, setPeriodicstatementsPreviousBackCursor] = useState<string | null>(null);
  const [periodicStatementsCursor, setPeriodicStatementsCursor] = useState<string | null>(null);
  const [periodicStatementsBackCursor, setPeriodicStatementsBackCursor] = useState<string | null>(null);
  const [statement, setStatement] = useState<PeriodicStatement | undefined>(undefined);
  useEffect(() => {
    const fetchUserStatementList = async (): Promise<void> => {
      setErrorMessage(null);
      if (membershipNumber != null) {
        setLoading(true);
        await getUserStatementList(CURSOR_FORWARD);
        setLoading(false);
      }
    };
    fetchUserStatementList();
  }, []);

  useEffect(() => {
    if (activePageNumber === lastActivePageNumber) {
      return;
    }
    const cursorDirection = activePageNumber > lastActivePageNumber ? CURSOR_FORWARD : CURSOR_BACKWARDS;
    setCursorDirection(cursorDirection);
    setLastActivePageNumber(activePageNumber);
    getUserStatementList(cursorDirection);
  }, [activePageNumber]);

  const getUserStatementList = async (cursorDirection: string): Promise<void> => {
    setLoading(true);
    try {
      const cursor =
        cursorDirection === CURSOR_FORWARD
          ? periodicStatementsCursor
          : activePageNumber > 1
          ? periodicStatementsPreviousBackCursor
          : null;
      const response = await periodicStatements.getUserStatementList(
        DEFAULT_USER_STATEMENTS_PER_PAGE,
        cursor,
        cursorDirection
      );
      const { content } = response;
      setPeriodicStatementsCursor(content?.LastEvaluatedKey ?? null);
      setPeriodicstatementsPreviousBackCursor(periodicStatementsBackCursor);
      setPeriodicStatementsBackCursor(content?.FirstEvaluatedKey ?? null);
      setTotalUserStatements(content?.total ?? 0);
      setUserStatementList(content?.list ?? []);
    } catch (err: unknown) {
      setErrorMessage(t("periodicStatements.error", { email: SUPPORT_EMAIL }));
      logger.error(err, LogTagKey.TKPeriodicStatements, "Error fetching user statement list", undefined);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserStatementData = async (statementId: string): Promise<PeriodicStatement | null> => {
    try {
      const response = await periodicStatements.getUserStatement(statementId);
      if (!response?.content) {
        throw new Error("Invalid statement id");
      }
      return response?.content;
    } catch (err: unknown) {
      setErrorMessage(t("periodicStatements.error", { email: SUPPORT_EMAIL }));
      logger.error(err, LogTagKey.TKPeriodicStatements, "Error fetching user statement", undefined, {
        statementId,
      });
      return null;
    }
  };

  const generatePDFName = (periodEndDate: string, firstName: string): string | null => {
    const MONTHS: string[] = [
      t("periodicStatements.months.january"),
      t("periodicStatements.months.february"),
      t("periodicStatements.months.march"),
      t("periodicStatements.months.april"),
      t("periodicStatements.months.may"),
      t("periodicStatements.months.june"),
      t("periodicStatements.months.july"),
      t("periodicStatements.months.august"),
      t("periodicStatements.months.september"),
      t("periodicStatements.months.october"),
      t("periodicStatements.months.november"),
      t("periodicStatements.months.december"),
    ];
    const date: Date = new Date(periodEndDate);
    try {
      return `${MONTHS[date.getMonth()]}${date.getFullYear()}_Bits_${firstName.replace(/ /g, "_")}.pdf`;
    } catch (err: unknown) {
      return null;
    }
  };

  const addFooter = (doc: jsPDF) => {
    const pages = doc.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(10);

    for (let j = 1; j < pages + 1; j++) {
      const horizontalPos = pageWidth - 10;
      const verticalPos = pageHeight - 10;
      doc.setPage(j);
      doc.text(`${j} of ${pages}`, horizontalPos, verticalPos, { align: "right" });
    }
  };

  const generatePDF = (): jsPDF => {
    const doc = new jsPDF();
    const startingPage = doc.getCurrentPageInfo().pageNumber;

    autoTable(doc, {
      html: `#accountNumberTable`,
      startY: 0,
      margin: { top: 10 },
      styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0], cellWidth: 80 },
        1: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      },
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.section === "body") {
          doc.addImage(BITS_LOGO_BASE_64, 2.5, 5, 45, 16.4);
        }
      },
    });
    autoTable(doc, {
      html: "#summaryAccountActivity",
      margin: { right: 120 },
      theme: "plain",
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.2,
      styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        1: { fillColor: [255, 255, 255], textColor: [0, 0, 0], cellWidth: 22 },
      },
      showHead: "firstPage",
      startY: 30,
      didDrawPage: function (data: any) {
        data.table.styles.bodyStyles.lineColor = [0, 0, 0];
        data.table.styles.bodyStyles.lineWidth = 1;
      },
      didParseCell: function (data: CellHookData) {
        if ((data.row.index === 4 || data.row.index === 5) && data.row.section === "body") {
          data.row.cells[0].styles.fontStyle = "bold";
        }
      },
    });
    doc.setPage(startingPage);
    autoTable(doc, {
      html: "#paymentsInformation",
      margin: { left: 95, bottom: 150 },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.2,
      styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        1: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      },
      showHead: "firstPage",
      startY: 30,
    });

    autoTable(doc, {
      html: "#questionsTable",
      margin: { right: 120 },
      styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      },
      showHead: "firstPage",
      // @ts-ignore
      startY: doc.lastAutoTable.finalY + 75 ?? 10,
    });

    autoTable(doc, {
      html: "#transactionsTable",
      margin: { top: 10 },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.2,
      styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        1: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        2: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        3: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      },
      // @ts-ignore
      startY: doc.lastAutoTable.finalY + 5 ?? 10,
      didParseCell: function (data: CellHookData) {
        if (data.row.index === 0 && data.row.section === "body") {
          data.row.cells[0].styles.fontStyle = "bold";
          data.row.cells[1].styles.fontStyle = "bold";
          data.row.cells[2].styles.fontStyle = "bold";
          data.row.cells[3].styles.fontStyle = "bold";
        }
      },
    });

    autoTable(doc, {
      html: `#yearTotals`,
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.2,
      styles: { fillColor: [184, 184, 184], textColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "left", minCellWidth: 120 },
        1: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "left", minCellWidth: 60 },
      },
    });

    autoTable(doc, {
      html: `#noticeTable`,
      styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "center" },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "center" },
      },
    });

    autoTable(doc, {
      html: `#footerTable`,
      styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "center" },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "right", minCellWidth: 90 },
        1: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "left", fontStyle: "bold" },
        2: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "left", minCellWidth: 20 },
      },
      didParseCell: function (data: CellHookData) {
        if (data.row.section === "body") {
          data.row.cells[1].styles.fontStyle = "bold";
          if (data.row.index === 3) {
            data.row.cells[2].styles.lineColor = [0, 0, 0];
            data.row.cells[2].styles.lineWidth = 0.2;
            data.row.cells[2].styles.cellPadding = 1;
            data.row.cells[2].styles.valign = "middle";
          }
        }
      },
      //@ts-ignore
      startY: doc.lastAutoTable.finalY + 5 ?? 10,
    });

    autoTable(doc, {
      html: `#creditorsAddressTable`,
      styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "left" },
      },
    });
    doc.addPage();

    autoTable(doc, {
      html: `#statementBacker`,
      styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
      columnStyles: {
        0: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: "left" },
      },
      didParseCell: function (data: CellHookData) {
        if ([1, 2].includes(data.row.index) && data.row.section === "body") {
          data.row.cells[0].styles.fontStyle = "bold";
        }
      },
    });
    return doc;
  };

  const downloadStatement = async (statementId: string): Promise<void> => {
    setErrorMessage(null);
    setDownloading(true);
    const statement: PeriodicStatement | null = await fetchUserStatementData(statementId);

    if (!statement) {
      return;
    }
    setStatement(statement);
    try {
      setTimeout(() => {
        const pdf: jsPDF = generatePDF();
        if (pdf) {
          const { periodEndDate, firstName } = statement;
          const pdfName: string | null = generatePDFName(periodEndDate, firstName);
          if (pdfName) {
            addFooter(pdf);
            pdf.save(pdfName);
          }
          setDownloading(false);
        }
      }, 1000);
    } catch (err: unknown) {
      setDownloading(false);
      setErrorMessage(t("periodicStatements.error", { email: SUPPORT_EMAIL }));
      logger.error(err, LogTagKey.TKPeriodicStatements, "Error downloading user statement", undefined, {
        statementId,
        email: statement?.email,
      });
    }
  };

  return {
    downloadStatement,
    userStatementList,
    loading,
    errorMessage,
    totalUserStatements,
    getUserStatementList,
    activePageNumber,
    setActivePageNumber,
    statement,
    downloading,
  };
};
